import BaseService from "../base";

class IndexService extends BaseService
{
    requestUrls = {

    }
}
export default IndexService;
